// extracted by mini-css-extract-plugin
module.exports = {"publicityDetail2":"detail2_publicityDetail2_12-pt"};